import { Injectable } from '@angular/core';
import { BaseListService } from './base-list.service';
import { BaseSearchModel } from '../../models/query/base-search.model';
import { GlobalComponent } from 'src/app/global-component';
import { tap, switchMap, BehaviorSubject, Observable } from 'rxjs';
import { FiniteStateMachineModel } from '../../models/finiteStateMachines/finite-state-machine.model';
import { SearchResultModel } from '../../models/query/search-result-model';
import { FsmApiService } from '../fsmApi.service';

export class FSMListState extends BaseSearchModel {
  createdById?: string;
  fsmId?: string; 
  order?: number;
}

@Injectable({
  providedIn: 'root'
})
export class FiniteStateMachineListService extends BaseListService{

  defaultFSMListState: FSMListState = {
    sortColumnDirective: '',
    sortDirectionDirective: 'desc',
    createdById: undefined,
    pageSize: GlobalComponent.defaultPagingInfo.pageSize,
    pageIndex: 0,
    startIndex: 0,
    sortColumn: '',
    sortDirection: 'desc',
    searchTerm: undefined
  };

  private _resultItems$ = new BehaviorSubject<FiniteStateMachineModel[]>([]);
  protected override _state: FSMListState = {...this.defaultFSMListState};

  constructor(
    protected fsmApiService: FsmApiService,
  ) {
    super();
    this._search$.pipe(
      tap(() => this._loading$.next(true)),
      switchMap(() => this._search()),
      tap(() => this._loading$.next(false))
    ).subscribe((result:any) => {
      this._resultItems$.next(result.items);
      this._total$.next(result.count);
    });
  }

  get resultItems$() { return this._resultItems$.asObservable(); }
  get createdById$() { return this._state.createdById; }

  set isEnabled(isEnabled: any) { this._set({ isEnabled }); }
  set createdById(createdById: any) { this._state.createdById = createdById }

  protected _search(): Observable<SearchResultModel<FiniteStateMachineModel> | undefined> {
    
    this.validateStartIndex();

    this._state.sortColumn = this.titleCaseWord(this._state.sortColumnDirective) as string;

    return this.fsmApiService.getFiniteStateMachinesList(this._state);
  }

  clearListService(){
    this._state = {...this.defaultFSMListState};
    this._resultItems$.next(new Array<FiniteStateMachineModel>());
    this._total$.next(0);
  }

}
